import { render, staticRenderFns } from "./stockDetail.vue?vue&type=template&id=906a821c&scoped=true"
import script from "./stockDetail.vue?vue&type=script&lang=js"
export * from "./stockDetail.vue?vue&type=script&lang=js"
import style0 from "./stockDetail.vue?vue&type=style&index=0&id=906a821c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906a821c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('906a821c')) {
      api.createRecord('906a821c', component.options)
    } else {
      api.reload('906a821c', component.options)
    }
    module.hot.accept("./stockDetail.vue?vue&type=template&id=906a821c&scoped=true", function () {
      api.rerender('906a821c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/leftMoudle/dialog/stockDetail.vue"
export default component.exports